import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import { createLocalAdapter } from "./app/localAdapter";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root mount point");

const adapter = await createLocalAdapter();

createRoot(root).render(
  <StrictMode>
    <App adapter={adapter} />
  </StrictMode>,
);
